const E = {
  'Yes - Attach Labels to Containers': 'Yes - Attach Labels to Containers',
  'Yes - Include, do not attach to containers':
    'Yes - Include, do not attach to containers',
  No: 'Not Required',
  'Use Sample ID': 'Use Sample ID',
  'Use Generic': 'Use Generic',
  'Do not include sample ID': 'Do not include sample ID',
  'Custom Labels': 'Custom Labels',
  'Company Name': 'Company Name',
  Project: 'Project',
  'Sample ID': 'Sample ID',
  'Enter Generic ID': 'Enter Generic ID',
  'Label Preview': 'Label Preview',
};

const F = {
  'Yes - Attach Labels to Containers':
    'Oui, mettre les étiquettes sur les contenants',
  'Yes - Include, do not attach to containers':
    'Oui, ajouter les étiquettes à l’envoi, ne pas les mettre sur les contenants',
  No: 'Non requis',
  'Use Sample ID': 'Utiliser l’ID de l’échantillon',
  'Use Generic': 'Utiliser le générique',
  'Do not include sample ID': 'Ne pas mettre l’ID de l’échantillon',
  'Custom Labels': 'Étiquettes personnalisées',
  'Company Name': 'Nom de l’entreprise',
  Project: 'Projet',
  'Sample ID': 'ID de l’échantillon',
  'Enter Generic ID': 'Mettre le générique',
    'Label Preview': 'Visualiser l’étiquette',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsLabels.js